import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/* Hands on table has some conflict issues w/ zone.js promise.  Need to make sure handsontable gets loaded before zone.js.  
Open issue w/ handsontable team as of 10/16/17.  For now, load handsontable in polyfills.js and  defer loading of zone.js to here, after
everytrhing else
*/
import 'zone.js/dist/zone.js';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts